import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var BadgeContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: ", ";\n  width: ", "px;\n  aspect-ratio: 1;\n  padding: 4px;\n\n  color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: 0.5px;\n  white-space: nowrap; // Impede quebra de texto\n  overflow: hidden; // Oculta conte\u00FAdo extra\n  line-height: 1; // Garante alinhamento correto\n  transition: font-size 0.2s ease-in-out;\n\n  & > span {\n    font-size: ", "px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: ", ";\n  width: ", "px;\n  aspect-ratio: 1;\n  padding: 4px;\n\n  color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: 0.5px;\n  white-space: nowrap; // Impede quebra de texto\n  overflow: hidden; // Oculta conte\u00FAdo extra\n  line-height: 1; // Garante alinhamento correto\n  transition: font-size 0.2s ease-in-out;\n\n  & > span {\n    font-size: ", "px;\n  }\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color ? color : theme.colors.primary.default;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var size = _a.size;
    return 0.5 * size;
}, function (_a) {
    var size = _a.size;
    return 0.5 * size;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map